import { type ComponentChildren } from 'preact';
import * as stylex from '@stylexjs/stylex';
import { styles } from './status-badge.styles';

// One canonical status tone → one colour meaning across the whole app:
//   good = healthy / active (online, on, healthy, present, live)
//   idle = inactive / absent (offline, off, retired, absent)
//   warn = attention / uncertain (unknown, stale)
//   bad  = fault
export type StatusTone = 'good' | 'idle' | 'warn' | 'bad';
interface StatusBadgeProps {
  tone: StatusTone;
  children: ComponentChildren;
  /** Show the leading status dot (default true). */
  dot?: boolean;
  /** Blink for attention — used on the "bad-but-important" states (offline, faulty). */
  pulse?: boolean;
}

/** The single status pill used everywhere: a tone-tinted fill + thin tone-coloured
 *  border + a matching dot, optionally blinking. Domain wrappers (LivenessBadge,
 *  ChannelHealthBadge, …) pick the tone/label so no surface hand-rolls status colours. */
export function StatusBadge({
  tone,
  children,
  dot = true,
  pulse = false
}: StatusBadgeProps) {
  return <span {...stylex.props(styles.base, styles[tone], pulse && styles.pulse)}>
      {dot && <span {...stylex.props(styles.dot, styles[`dot_${tone}` as const])} />}
      {children}
    </span>;
}